// extracted by mini-css-extract-plugin
module.exports = {"infoWrapper":"ClientEmergencyInfo_infoWrapper__1YEk-","itemTitle":"ClientEmergencyInfo_itemTitle__2Hc-B","itemText":"ClientEmergencyInfo_itemText__1_x21"};